/* eslint-disable linebreak-style */
import { createSlice } from '@reduxjs/toolkit';
import apiClient from 'root/lib/apiClient';
import map from 'base-ui/dist/underline/map';
import has from 'base-ui/dist/underline/has';
import { Sentry } from 'root/utils/raven';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const initialState = {
  items: {},
  fetched: {},
  isLoading: false,
  error: null,
  configAuth: {}
};

const menusSlice = createSlice({
  name: 'menus',
  initialState,
  reducers: {
    getConfigAuth(state, action) {
      state.configAuth = action.payload;
    },
    getMenuStart(state) {
      state.isLoading = true;
    },
    getMenuSuccess(state, { payload: { slug, data } }) {
      state.items[slug] = data;
      state.fetched[slug] = true;
      state.isLoading = false;
      state.error = null;
    },
    getMenuFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    }
  },
});

export const {
  getMenuStart,
  getMenuSuccess,
  getMenuFailure,
  getConfigAuth
} = menusSlice.actions;

export default menusSlice.reducer;

export const fetchMenu = (slug) => async (dispatch, getState) => {
  const { menus } = getState();
  if (menus.fetched[slug]) {
    dispatch(getMenuSuccess({
      slug,
      data: menus.items[slug]
    }));
  } else {
    try {
      dispatch(getMenuStart());
      let data = await apiClient({ method: 'GET', url: `/wp-json/mc/v1/menus/${slug}` });
      data = map(data, (d) => (
        {
          ...d,
          label: d.title,
          url: d.type === 'taxonomy' ? `/category?permalink=${d.permalink}` : d.permalink,
          as: d.permalink.replace(publicRuntimeConfig.PUBLIC_URL, ''),
          withRouter: has(d, 'permalink'),
          children: d.children ? map(d.children, (c) => (
            {
              ...c,
              label: c.title,
              url: c.type === 'taxonomy' ? `/category?permalink=${c.permalink}` : c.permalink,
              as: c.permalink.replace(publicRuntimeConfig.PUBLIC_URL, ''),
              withRouter: has(c, 'permalink'),
              children: c.children ? map(c.children, (e) => (
                {
                  ...e,
                  label: e.title,
                  url: e.type === 'taxonomy' ? `/category?permalink=${e.permalink}` : e.permalink,
                  as: e.permalink.replace(publicRuntimeConfig.PUBLIC_URL, ''),
                  withRouter: has(e, 'permalink'),
                }
              )) : []
            }
          )) : []
        }
      ));
      dispatch(getMenuSuccess({
        slug,
        data,
      }));
    } catch (e) {
      dispatch(getMenuFailure(e.toString()));
      Sentry.captureException(e);
    }
  }
};

export const fetchMenuHeader = () => async (dispatch) => {
  const promises = [];
  promises.push(dispatch(fetchMenu('main')));
  return Promise.all(promises);
};

export const fetchMenuFooter = () => async (dispatch) => {
  const promises = [];
  ['legal', 'social_links', 'external_links', 'version_links'].map((slug) => promises.push(dispatch(fetchMenu(slug))));
  return Promise.all(promises);
};
